import {createRouter, createWebHistory} from 'vue-router'
import ToolsHome from "./ToolsHome.vue";
import ButtonExplorer from "./ButtonExplorer.vue";
import AiHome from "./AiHome.vue";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/tailwind-tools',
            name: 'home',
            component: ToolsHome,
        },
        {
            path: '/tailwind-tools/tailwind-button-explorer',
            name: 'buttons',
            component: ButtonExplorer,
        },
        {
            path: '/tailwind-tools/ai',
            name: 'ai',
            component: AiHome,
        }
    ]
})

export default router